import { pickupAddressEntity } from "../domain/entities/pickup_address";
import http from "../../../plugins/http-common"
// import i18n from "../../../../i18n";

export const HttpPickupAddressRepository = {
  model: pickupAddressEntity,

  async index(client_id) {
    const res = await http.get('api/shipping_guides/pickup_addresses/index?client_id=' + client_id);

    const arr = [];

    res.data.forEach( x => {
      x = x.data;
      var id = x.id;
      x = x.attributes;
      x.id = id;
      x.address.direction = x.address.street + " " + x.address.external_number + (x.address.internal_number != null ? " " + x.address.internal_number : "")

      arr.push(x);
    })
    
    return arr;
  },

  async create(data){
    const res = await http.post('/api/shipping_guides/pickup_addresses', data);

    return res
  }
};